import { Text, View } from "react-native";
import { styles } from "./styles";

interface ResponseDisplayProps {
  label: string;
  response: string;
}

export const ResponseDisplay = ({ label, response }: ResponseDisplayProps) => {
  if (!response) return null;

  return (
    <View style={styles.responseContainer}>
      <Text style={styles.responseLabel}>{label}</Text>
      <Text style={styles.responseText}>{response}</Text>
    </View>
  );
};
